import { toast } from 'react-toastify'

const handleCopyValue = ({ t = () => {}, value }: any) => {
  // navigator.clipboard 只支援 https 跟 localhost
  if (navigator.clipboard) {
    navigator.clipboard.writeText(value)

    toast.success(t('Common_Copy_Success'))
  } else {
    const element = document.createElement('textarea')
    element.value = value

    element.setAttribute('readonly', '')

    document.body.appendChild(element)

    element.select()

    const isCopied = document.execCommand('copy')

    document.body.removeChild(element)

    if (isCopied) {
      toast.success(t('Common_Copy_Success'))
    } else {
      toast.error(t('Common_Copy_Fail'))
    }
  }
}

export default handleCopyValue
